<template>
  <div class="manage-purchases">
    <b-input
      v-model="filter"
      placeholder="Search..."
      class="mb-3"
    />
    <b-table
      :items="requests"
      :fields="tableFields"
      :sort-compare-options="compareOptions"
      :filter="filter"
      small striped hover responsive>
      <template #cell(listing.title)="data">
        <router-link
          :to="`/listing/${data.item.listing.id}`"
          :title="data.item.listing.title"
          class="text-dark">
          {{ data.item.listing.title | truncate }}
        </router-link>
      </template>
      <template #cell(buyername)="data">
        {{  data.item.buyer.firstName }} {{ data.item.buyer.lastName }}
      </template>
      <template #cell(status)="data">
        <b-badge :variant="getStatusVariant(data.item.status)">
          {{ data.item.status }}
        </b-badge>
      </template>
      <template #cell(sellername)="data">
        {{ data.item.seller.firstName }} {{ data.item.seller.lastName }}
      </template>
      <template #cell(lastactivity)="data">
        {{ data.item.updatedAt | date }} ({{ data.item.updatedAt | relativeDate }})
      </template>
      <template #cell(actions)="data">
        <a
          href="javascript:void(0);"
          class="text-primary font-weight-bold"
          @click="openMessages(data.item.id)">
          View Messages
        </a>
      </template>
    </b-table>
    <b-modal
      id="messages"
      title="Messages"
      no-close-on-backdrop
      ok-only
      >
      <div class="messages">
        <div
          v-if="isMessagesLoading"
          class="py-3 text-center">
          <h3>
            Loading...
          </h3>
        </div>
        <div
          v-else-if="messages.length"
          class="messages__message p-2 mb-3"
          v-for="message in messages"
          :key="message.id">
          {{ message.message }}
          <div class="messages__meta">
            {{ message.sender.firstName }}
            {{ message.sender.lastName }}
            on
            {{ message.createdAt | date }}
          </div>
        </div>
        <div
          class="text-center"
          v-else>
          <h3>
            No messages found.
          </h3>
          <p>
            This purchase has no messages.
            Remember: messaging is not available
            until a Purchase Request is confirmed by
            the Seller.
          </p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import date from '@/filters/date.filter'
import relativeDate from '@/filters/relativeDate.filter'

const truncate = (val) => {
  if (!val) return ''
  const maxLength = 17
  return val.length > maxLength
    ? `${val.substring(0, maxLength)}...`
    : val
}

export default {
  name: 'ManagePurchases',
  filters: {
    date,
    relativeDate,
    truncate,
  },
  data() {
    return {
      messages: [],
      isMessagesLoading: false,
      filter: '',
      requests: [],
      compareOptions: {
        ignorePunctuation: true,
      },
      tableFields: [
        {
          key: 'listing.title',
          label: 'Listing Title',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'buyername',
          label: 'Buyer',
          sortable: true,
        },
        {
          key: 'sellername',
          label: 'Seller',
          sortable: true,
        },
        {
          key: 'lastactivity',
          label: 'Last Activity',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    async fetchMessages(requestsId) {
      this.isMessagesLoading = true
      const { data: { messages } } = await this.$http.get(`/admin/request/${requestsId}/messages`)
      this.messages = messages
      this.isMessagesLoading = false
    },
    async fetchPurchases() {
      const { data: { requests } } = await this.$http.get('/admin/purchases')
      this.requests = requests
    },
    openMessages(requestsId) {
      this.fetchMessages(requestsId)
      this.$bvModal.show('messages')
    },
    getStatusVariant(status) {
      switch (status) {
        case 'Confirmed':
          return 'success'
        case 'Expired':
          return 'danger'
        case 'Pending':
          return 'warning'
        default:
          return undefined
      }
    },
  },
  created() {
    this.fetchPurchases()
  },
}
</script>

<style lang="scss" scoped>
.messages__message {
  background-color: #f7f7f7;
}

.messages__meta {
  font-size: 0.8rem;
  margin: 0;
  opacity: 0.8;
  padding: 0;
}
</style>
